import { TrackableType } from "@redotech/redo-model/trackable";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { TrackingTypeState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/tracking-type";
import { Flex } from "@redotech/redo-web/flex";
import { RadioGroup } from "@redotech/redo-web/radio";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const TrackingTypeDetails = memo(function TrackingTypeDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<TrackingTypeState>) {
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Tracking type
      </Text>
      <RadioGroup
        disabled={disabled}
        optionLabel={(option: TrackableType) =>
          ({
            order: "Order",
            return: "Return",
            fulfillment_group: "Fulfillment Group",
          })[option]
        }
        options={[TrackableType.ORDER, TrackableType.RETURN]}
        value={state as TrackableType}
        valueChange={(value: string) => setState(value)}
      />
      <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
        Select the type of tracking page you&apos;d like this condition to apply
        to
      </Text>
    </Flex>
  );
});
